module.exports = __webpack_public_path__ + "img/waterx-ia-logo-figma-cropped.e0e89428.png";